<template>
<div class="chapter">
<div class="inner_page">
<p class="C128"><span class="size_140"><strong><span id="page_1">PART</span> 1</strong></span></p>
<p class="C128"><span class="size_150"><em>A Kid from Bridgeport</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_PART_1_.vue?35ef9d62